import { differenceInDays, format } from 'date-fns';
import { toast } from 'react-toastify';
import resourceEmptyImage from '../asset/images/resource_notfound.svg';
import unreadNotFound from '../asset/images/unreadTab_notfound.svg';
import bookmarkNotFound from '../asset/images/bookmark_notfound.svg';
import gesturingGrade from '../asset/images/gesturingGrade.png';
import checkCircleProgress from '../asset/images/check-circle-progress.svg';
import gesture_ok from '../asset/icons/gesture_ok.png';
import { ROUTES } from '../config/routes';
import { backendBaseUrl } from '../api/config';
import pdfIcon from '../asset/images/pdf-icon.png';
import zipIcon from '../asset/images/zip-icon.png';
import imageIcon from '../asset/images/image-icon.png';
import docIcon from '../asset/images/doc-icon.png';
import videoIcon from '../asset/images/video-icon.png';
import otherIcon from '../asset/images/other-icon.png';
import pdfIconDark from '../asset/images/pdf-icon-dark.png';
import zipIconDark from '../asset/images/zip-icon-dark.png';
import imageIconDark from '../asset/images/image-icon-dark.png';
import docIconDark from '../asset/images/doc-icon-dark.png';
import videoIconDark from '../asset/images/video-icon-dark.png';
import otherIconDark from '../asset/images/other-icon-dark.png';
import skillSyncIcon from '../asset/images/SkillSyncIcon.svg';
import skillSyncSelectedIcon from '../asset/images/SkillSyncSelectedIcon.svg';
import { HOME_SECTIONS } from '../config/cleverTapEvents';
import SuccessToastMessage from '../@common/SuccessToast/SuccessToast';
import { Route } from 'react-router-dom';

const constantLogin = {
  emptyMessage: 'Please enter a valid mobile number or email address.',
  emptyMessageOtp: 'Please enter a valid OTP.'
};
// Think we have /:progamId/:activity/:quizId
function handleStringToNumber(input) {
  if (input === null) {
    return 0;
  }
  const number = Number(input);
  return isNaN(number) ? 0 : number;
}
const LiveIcon = ({ circleFill = '#EF5054', playFill = '#FDFDFD' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='33'
    height='32'
    viewBox='0 0 33 32'
    fill='none'
  >
    <circle cx='16.5' cy='16' r='12' fill={circleFill} />
    <path
      d='M13.3298 12.6884V19.314C13.3298 19.8255 13.5507 20.1975 13.9924 20.43C14.4341 20.6624 14.8642 20.6392 15.2827 20.3602L20.4786 17.0822C20.8738 16.8265 21.0714 16.4662 21.0714 16.0012C21.0714 15.5362 20.8738 15.1759 20.4786 14.9202L15.2827 11.6422C14.8642 11.3632 14.4341 11.34 13.9924 11.5724C13.5507 11.8049 13.3298 12.1769 13.3298 12.6884Z'
      fill={playFill}
    />
  </svg>
);

const constantSignUp = {
  emptyMessage: 'Please enter a valid mobile number.'
};

//format: Monday, 2 September 2021
const DATE_WEEK_STRING_FORMAT = 'EEEE, do MMMM yyyy';
const DATE_WEEKTIME_STRING_FORMAT = 'EEEE, do MMMM yyyy HH:mm a';
const ACCESS_TYPE = {
  Premium: 'Premium',
  Free: 'Free'
};
const formatDate = (dateString, outputFormat) => {
  const date = new Date(dateString);
  const formattedDate = format(date, outputFormat);
  return formattedDate;
};
const courseStatusVal = {
  Recommended: 'Recommended',
  Ongoing: 'Ongoing',
  Locked: 'Locked',
  Unlocked: 'Unlocked',
  Completed: 'Completed'
};
// To get the status text and icon for the course module.
// status:number
const courseStatus = (status) => {
  switch (status) {
    case courseStatusVal.Recommended:
      return {
        icon: <span className='material-symbols-outlined'>hotel_class</span>
      };
    case courseStatusVal.Ongoing:
      return {
        icon: <span className='material-symbols-outlined'>play_arrow</span>
      };
    case courseStatusVal.Locked:
      return {
        disable: true,
        icon: <span className='material-symbols-outlined'>lock</span>
      };
    case courseStatusVal.Unlocked:
      return {
        icon: <span className='material-symbols-outlined'>lock_open</span>
      };
    case courseStatusVal.Completed:
      return {
        icon: <span className='material-symbols-outlined'>done</span>
      };
    default:
      return false;
  }
};
const handleRedirection = (
  type,
  val,
  navigate,
  programId = 0,
  cmid = false
) => {
  const cmId = cmid ? cmid : val?.cmid || val?.details?.cmid;
  const url =
    val?.url ||
    val?.activityurl ||
    val?.sectionurl ||
    backendBaseUrl + '/mod/' + type + '/view.php' + '?id=' + cmId;

  switch (type) {
    case 'refer':
      navigate(ROUTES.REFER_N_EARN);
      return null;

    case 'quiz':
    case 'url':
    case 'hvp':
    case 'page':
    case 'folder':
    case 'resource':
    case 'videofile':
    case 'scorm':
    case 'handson':
      navigate(
        ROUTES.PAGE_ACTIVITY.replace(':programid', programId)
          .replace(':type', type)
          .replace(':id', cmId)
      );
      return null;
    case 'feedback':
      navigate(
        ROUTES.PAGE_ACTIVITY.replace(':programid', programId)
          .replace(':type', 'feedback')
          .replace(':id', cmId)
      );
      return null;
    case 'zoom':
    case 'zoomduplicate':
      const currentSeconds = Math.floor(Date.now() / 1000);
      // if (
      //   handleStringToNumber(val?.timestart) - currentSeconds <= 900 &&
      //   handleStringToNumber(val?.timestart) - currentSeconds >= 0
      // ) {
      //   navigate(ROUTES.ZOOM.replace(':id', cmId));
      // } else {
      navigate(
        ROUTES.PAGE_ACTIVITY.replace(':programid', programId)
          .replace(':type', type)
          .replace(':id', cmId)
      );
      // }
      return null;
    case 'page':
      navigate(
        ROUTES.PAGE_ACTIVITY.replace(':type', 'page')
          .replace(':id', cmId)
          .replace(':programid', programId)
      );
      return null;
    case 'folder':
      navigate(
        ROUTES.PAGE_ACTIVITY.replace(':type', 'folder')
          .replace(':id', cmId)
          .replace(':programid', programId)
      );
      return null;
    case 'forum':
      navigate(
        ROUTES.PAGE_ACTIVITY.replace(':type', 'forum')
          .replace(':id', cmId)
          .replace(':programid', programId)
      );
      return null;
    case 'resource':
      navigate(
        ROUTES.PAGE_ACTIVITY.replace(':type', 'resource')
          .replace(':id', cmId)
          .replace(':programid', programId)
      );
      return null;
    case 'assign':
      navigate(
        ROUTES.PAGE_ACTIVITY.replace(':type', 'assign')
          .replace(':id', cmId)
          .replace(':programid', programId)
      );
      return null;
    default:
      window.open(
        url + '&token=' + btoa(localStorage.getItem('token')),
        '_blank'
      );
      return null;
  }
};
const activityIcon = (val, otherColor1 = '') => {
  const otherColor = otherColor1;
  switch (val) {
    case 'quiz':
      return {
        icon: (
          <span
            className='material-symbols-rounded icon'
            style={{ color: 'var(--primary-text-color)' }}
          >
            contact_support
          </span>
        ),
        color: 'var(--accent-tertiary-orange-color)',
        title: 'Quiz'
      };

    case 'assign':
      return {
        icon: (
          <span
            className='material-symbols-rounded icon'
            style={{ color: 'var(--primary-text-color)' }}
          >
            assignment
          </span>
        ),
        color: 'var(--accent-tertiary-purple-color)',
        title: 'Assignment'
      };

    case 'zoom':
      return {
        icon: (
          <span
            className='material-symbols-rounded icon'
            style={{ color: 'var(--primary-text-color)' }}
          >
            live_tv
          </span>
        ),
        color: 'var(--accent-tertiary-green-color)',
        title: 'Session',
        activitytitle: 'Zoom Session'
      };
    case 'zoomduplicate':
      return {
        icon: (
          <span
            className='material-symbols-rounded icon'
            style={{ color: 'var(--primary-text-color)' }}
          >
            live_tv
          </span>
        ),
        color: 'var(--accent-tertiary-green-color)',
        title: 'Session'
      };

    case 'videofile':
      return {
        icon: (
          <span
            className='material-symbols-rounded icon'
            style={{ color: 'var(--primary-text-color)' }}
          >
            play_circle
          </span>
        ),
        color: otherColor,
        title: 'Video'
      };

    case 'folder':
      return {
        icon: (
          <span
            className='material-symbols-rounded icon'
            style={{ color: 'var(--primary-text-color)' }}
          >
            folder_open
          </span>
        ),
        color: otherColor,
        title: 'Folder'
      };

    case 'url':
      return {
        icon: (
          <span
            className='material-symbols-rounded icon'
            style={{ color: 'var(--primary-text-color)' }}
          >
            link
          </span>
        ),
        color: otherColor,
        title: 'Url'
      };

    case 'forum':
      return {
        icon: (
          <span
            className='material-symbols-rounded icon'
            style={{ color: 'var(--primary-text-color)' }}
          >
            forum
          </span>
        ),
        color: otherColor,
        title: 'Forum'
      };

    case 'handson':
      return {
        icon: <span class='material-symbols-outlined'>terminal</span>,
        color: otherColor,
        title: 'Playground'
      };

    case 'scorm':
      return {
        icon: (
          <span
            className='material-symbols-rounded'
            style={{ color: 'var(--primary-text-color)' }}
          >
            co_present
          </span>
        ),
        color: otherColor,
        title: 'Scorm'
      };

    case 'hvp':
      return {
        icon: (
          <span
            className='material-symbols-rounded icon'
            style={{ color: 'var(--primary-text-color)' }}
          >
            award_star
          </span>
        ),
        color: otherColor,
        title: 'Hvp'
      };

    case 'page':
      return {
        icon: (
          <span
            className='material-symbols-rounded icon'
            style={{ color: 'var(--primary-text-color)' }}
          >
            draft
          </span>
        ),
        color: otherColor,
        title: 'Page'
      };

    case 'resource':
      return {
        icon: (
          <span
            className='material-symbols-rounded icon'
            style={{ color: 'var(--primary-text-color)' }}
          >
            lab_profile
          </span>
        ),
        color: otherColor,
        title: 'Resource'
      };

    case 'feedback':
      return {
        icon: (
          <span
            className='material-symbols-rounded icon'
            style={{ color: 'var(--primary-text-color)' }}
          >
            reviews
          </span>
        ),
        color: 'var(--accent-tertiary-yellow-color)',
        title: 'Feedback'
      };

    default:
      return {
        icon: (
          <span
            className='material-symbols-rounded icon'
            style={{ color: 'var(--primary-text-color)' }}
          >
            web_asset
          </span>
        ),
        title: val,
        color: otherColor
      };
  }
};
const getStatus = (status) => {
  switch (status) {
    case 'due':
    case 'due on':
    case 'live':
      return { title: status, color: '#EF5054' };
    case 'not submitted':
    case 'not attended':
    case 'not available':
      return {
        title: status,
        color: 'var(--quartinary-text-color)'
      };
    default:
      return {
        title: status,
        color: 'var(--accent-primary-dark-green-color)'
      };
  }
};

const PROGRESS_TAB = {
  progress: 1,
  grade: 3
};
const getUrlQueryParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const queryParams = {};

  // Iterate over each query parameter and add it to the object
  for (let param of searchParams.entries()) {
    const [key, value] = param;
    queryParams[key] = value;
  }

  return queryParams;
};

const searchPopover = [
  { title: 'All', id: 0 },
  { title: 'Classes and Sessions', id: 1 },
  { title: 'Learning Resources', id: 2 },
  { title: 'Assignments', id: 3 },
  { title: 'Quizzes', id: 4 },
  { title: 'Topics', id: 5 }
];
const resourceSidebarNavItem = {
  RESOURCE: {
    key: 'resource',
    name: 'All Resources',
    title: 'No resources found',
    imagePath: resourceEmptyImage,
    icon: <span class='material-symbols-outlined icon'>article</span>
  },
  UNREAD: {
    name: 'Unread',
    key: 'unread',
    title: 'You have read all resources',
    imagePath: unreadNotFound,
    icon: <span class='material-symbols-outlined icon'>wysiwyg</span>
  },
  SAVED: {
    name: 'Saved',
    key: 'saved',
    title: 'Saved resources would appear here',
    imagePath: bookmarkNotFound,
    icon: <span class='material-symbols-outlined icon'>bookmark</span>
  }
};

function calculatePercentage(value, total, fixedStep = 2) {
  value = Number(value);
  total = Number(total);
  if (total === 0) {
    return '--';
  }

  var percentage = (value / total) * 100;

  if (Number.isInteger(percentage)) {
    return percentage.toFixed(0);
  } else {
    // Check if the percentage ends with ".00"
    if (percentage.toFixed(fixedStep).endsWith('.00')) {
      return percentage.toFixed(0);
    } else {
      return percentage.toFixed(fixedStep);
    }
  }
}

const CURRENT_INDUSTRY = [
  'Select an Option',
  'Analytics / Research / KPO',
  'BPO / Call Centre',
  'IT Services & Consulting',
  'Electronics & Semiconductors',
  'Emerging Technologies',
  'AI / ML',
  'Blockchain',
  'Cloud Computing',
  'Cybersecurity',
  'Drones & Robotics',
  'IoT',
  'Hardware & Networking',
  'E-Commerce',
  'Internet & Digital Services',
  'Software Products',
  'Banking & Financial Services',
  'Asset Management',
  'Broking',
  'FinTech & Payments',
  'Insurance',
  'Investment Banking / Venture Capital / Private Equity',
  'NBFC',
  'Education & Training',
  'EdTech',
  'Automotive & Auto Components',
  'Electric Vehicles (EV)',
  'Building Materials',
  'Chemicals & Paints',
  'Defence & Aerospace',
  'Electrical Equipment',
  'Agriculture Chemicals / Fertilizers / Pesticides',
  'Industrial Automation & Machinery',
  'Metals & Mining',
  'Packaging',
  'Petrochemicals & Plastics',
  'Pulp & Paper',
  'Aviation',
  'Logistics & Supply Chain',
  'Engineering & Construction',
  'Ports & Shipping',
  'Power & Energy',
  'Renewable Energy',
  'Railways',
  'Real Estate & Infrastructure',
  'Water & Waste Management',
  'Beauty & Personal Care',
  'Beverages & Alcohol',
  'Consumer Electronics & Appliances',
  'Fitness & Wellness',
  'FMCG',
  'Food Processing',
  'Retail',
  'Gems & Jewellery',
  'Hotels & Restaurants',
  'Textiles & Apparel',
  'Fashion & Lifestyle',
  'Travel & Tourism',
  'Biotechnology',
  'Clinical Research & Contract Research',
  'Medical Devices & Equipment',
  'Healthcare & Hospitals',
  'Pharmaceuticals & Life Sciences',
  'Advertising & Marketing',
  'Digital Marketing',
  'Public Relations',
  'Media & Entertainment',
  'Gaming',
  'Printing & Publishing',
  'Sports & Recreation',
  'Telecom & ISP',
  'Accounting & Auditing',
  'Architecture & Interior Design',
  'Content Development',
  'Design Services',
  'Facility Management',
  'Legal Services',
  'Management Consulting',
  'Recruitment & Staffing',
  'Agriculture & Agri-tech',
  'Government & Public Sector',
  'Import & Export',
  'NGO & Social Services',
  'Other'
];
const PREFERRED_CITY_LIST = [
  'Ahmedabad',
  'Bengaluru',
  'Bhopal',
  'Bhubaneshwar',
  'Chandigarh',
  'Chennai',
  'Cochin',
  'Coimbatore',
  'Dehradun',
  'Delhi',
  'Gandhinagar',
  'Ghaziabad',
  'Gurugram',
  'Guwahati',
  'Gwalior',
  'Hyderabad',
  'Indore',
  'Jaipur',
  'Kochi',
  'Kolkata',
  'Madurai',
  'Mohali',
  'Mumbai',
  'Mysore',
  'Nagpur',
  'Nashik',
  'Navi Mumbai',
  'Noida',
  'Patna',
  'Pune',
  'Raipur',
  'Rajkot',
  'Ranchi',
  'Surat',
  'Trivandrum',
  'Vadodara',
  'Vishakhapatnam'
];
const SOCIAL_PROFILE = ['Select an option', 'LinkedIn', 'GitHub', 'Kaggle'];
const SKILLS_PLACEHOLDER = [
  'e.g. Leadership',
  'e.g. SQL',
  'e.g. Corporate Finance'
];
const UG_COURSE_LIST = [
  'B.Tech/B.E.',
  'B.Com',
  'B.Sc',
  'B.A',
  'Diploma',
  'B.Arch',
  'B.B.A/B.M.S',
  'B.Des.',
  'B.Ed',
  'B.EI.Ed',
  'B.P.Ed',
  'B.Pharma',
  'B.U.M.S',
  'BAMS',
  'BCA',
  'BDS',
  'BFA',
  'BHM',
  'BHMCT',
  'BHMS',
  'BVSC',
  'LLB',
  'MBBS',
  'IIM 5-year Integrated Mgmt. Programme',
  'Others'
];
const PG_COURSE_LIST = [
  'MBA/PGDM',
  'M.Tech',
  'MS/M.Sc(Science)',
  'MVA',
  'M.Com',
  'PG Diploma',
  'MA',
  'CA',
  'CS',
  'DM',
  'ICWA(CMA)',
  'Integrated PG',
  'LLM',
  'M.Arch',
  'M.Ch',
  'M.Des',
  'M.Ed',
  'M.Pharma',
  'MCM',
  'MDS',
  'Medical-MS/MD',
  'MFA',
  'MVCS',
  'Others'
];
const handleLastDecimalChange = (e) => {
  let value = e.target.value;
  if (value[value.length - 1] === '.') {
    value = value.substring(0, value.length - 1);
  }
  e.target.value = value;
  return e;
};

function getDaysDiff(startDate, endDate) {
  const diffInDays = differenceInDays(endDate, startDate);

  return diffInDays;
}
const DEFAULT_SOCIAL_PROFILE_SELECT_OPTION = 'Select an option';

const parseQueryParams = (queryString) => {
  const urlParams = new URLSearchParams(queryString);
  const queryParams = {};
  for (const [key, value] of urlParams.entries()) {
    queryParams[key] = value;
  }
  return queryParams;
};

const htmlDataParser = (htmlData) => {
  // Create a new HTML document
  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(htmlData, 'text/html');

  // Get the text content of the root element
  const textContent = htmlDoc.documentElement.textContent;
  return textContent;
};

const getIp = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    toast.error('Failed to retrieve IP address.');
  }
};
const parseInteger = (input) => {
  if (input?.length) {
    const result = parseFloat(input);
    return isNaN(result) ? input : result;
  }
  return input;
};
const PER_PAGE = 10;

const progressSectionCardDetails = [
  {
    title: '-',
    subTitle: 'My Grade',
    content: 'Grades are not available at the moment',
    badgeIcon: gesture_ok,
    badgeContent: '',
    icon: gesturingGrade,
    titlePostFix: '%',
    tooltipContent:
      'Your Program Grade till date across all courses where grading is enabled. You must achieve a minimum of 60% grade for program completion',
    recenttooltipContent:
      'Your Program Grade till date across all courses where grading is enabled. You must achieve a minimum of 60% grade for program completion'
  },
  {
    title: '-',
    subTitle: 'Attendance',
    contentAtt: 'Attendance is not available at the moment',
    badgeIcon: '../../asset/icons/check_circle.png',
    badgeContent: '',
    iconAtt: checkCircleProgress,
    titlePostFix: '%',
    tooltipContent:
      'Your attendance for the mandatory lectures and other sessions'
  }
];

const SUPPORTED_PAGE_ACTIVITY = {
  page: {
    title: 'page',
    icon: <span class='material-symbols-outlined'>contract</span>,
    clevertapKey: 'Page'
  },
  feedback: {
    title: 'feedback',
    icon: <span class='material-symbols-outlined'>reviews</span>,
    clevertapKey: 'Feedback'
  },
  resource: {
    title: 'resource',
    icon: <span class='material-symbols-outlined'>file_copy</span>,
    clevertapKey: 'File'
  },
  quiz: {
    title: 'quiz',
    icon: <span class='material-symbols-outlined'>contact_support</span>,
    clevertapKey: 'Quiz'
  },
  videofile: {
    title: 'videofile',
    icon: <span class='material-symbols-outlined'>play_circle</span>,
    clevertapKey: 'Video'
  },
  folder: {
    title: 'folder',
    icon: <span class='material-symbols-outlined'>folder_open</span>,
    clevertapKey: 'Folder'
  },
  zoom: {
    title: 'zoom',
    icon: <span class='material-symbols-outlined'>live_tv</span>,
    clevertapKey: 'Zoom'
  },
  zoom_duplicate: {
    title: 'zoomduplicate',
    icon: <span class='material-symbols-outlined'>live_tv</span>,
    clevertapKey: 'Zoom_Duplicate'
  },
  scorm: {
    title: 'scorm',
    icon: <span class='material-symbols-outlined'>web_asset</span>,
    clevertapKey: 'Scorm'
  },
  hvp: {
    title: 'hvp',
    icon: <span class='material-symbols-outlined'>award_star</span>,
    clevertapKey: 'Hvp'
  },
  url: {
    title: 'URL',
    icon: <span class='material-symbols-outlined'>link</span>,
    clevertapKey: 'URL'
  },
  assign: {
    key: 'assign',
    title: 'assignment',
    icon: <span class='material-symbols-outlined'>assignment</span>,
    clevertapKey: 'Assignment'
  },
  doselect: {
    title: 'doselect',
    icon: <span class='material-symbols-outlined'>contact_support</span>,
    clevertapKey: 'DoSelect_Quiz'
  },
  forum: {
    title: 'forum',
    icon: <span class='material-symbols-outlined'>forum</span>
  }
};
const QUIZ_TYPE = {
  truefalse: 'True False',
  multichoice: 'Mutiple choice (Multiple correct)',
  singlechoice: 'Mutiple choice (Single correct)',
  essay: 'Essay',
  shortanswer: 'Short answer'
};
const QUIZ_ANSWER_STATUS = {
  1: {
    title: 'Your answer is correct',
    key: ''
  },
  2: {
    title: 'Your answer is partially correct'
  },
  0: {
    title: 'Your answer is incorrect'
  },
  '-1': {
    title: ''
  }
};

const getUrlReplace = (fileUrl = '', token) => {
  if (fileUrl?.includes(backendBaseUrl)) {
    return (
      fileUrl.replace('/pluginfile.php', '/webservice/pluginfile.php') +
      '?token=' +
      token
    );
  } else {
    return fileUrl;
  }
};

const getFileType = (file, uploaded = false, token) => {
  const fileTypeParts = !uploaded
    ? file?.type?.split('/')
    : file?.mimetype?.split('/');
  const fileExtension =
    fileTypeParts?.length > 1 ? fileTypeParts[1] : file?.type || file?.mimetype;
  if (fileExtension === 'pdf') {
    return (
      <span class='material-symbols-outlined' style={{ color: '#F40F02' }}>
        picture_as_pdf
      </span>
    );
  } else if (
    ['jpeg', 'jpg', 'png', 'gif', 'bmp', 'svg+xml'].includes(fileExtension)
  ) {
    return (
      <img
        src={
          file?.fileurl?.length
            ? file?.fileurl.replace(
                '/pluginfile.php',
                '/webservice/pluginfile.php'
              ) +
              `&token=` +
              token
            : URL.createObjectURL(file)
        }
        className='img-img'
      />
    );
  } else if (['mp4', 'avi', 'mkv', 'mov'].includes(fileExtension)) {
    return <span class='material-symbols-outlined'>play_circle</span>;
  } else {
    return <span class='material-symbols-outlined'>description</span>;
  }
};
const data = [
  {
    title: 'Live Sessions',
    key: 'Lectures',
    required: true,
    toolTipContent: `Attendance in ‘live sessions’ is mandatory for program completion`,
    type: 1,
    color: '#FAB300'
  },
  {
    title: 'Doubt Clearing Sessions',
    key: 'doubt',
    toolTipContent:
      'These sessions are optional but important for your learning',
    type: 2,
    color: '#5095FC',
    required: false
  },
  {
    title: 'Practice Sessions',
    key: 'practice',
    toolTipContent:
      'These sessions are optional but important for your learning',
    type: 1,
    color: '#8816BD',
    required: false
  },
  {
    title: 'Other Sessions',
    key: 'other',
    required: false,
    toolTipContent:
      'These sessions are optional but important for your learning',
    type: 2,
    color: '#F8752B'
  }
];
const carreerSession = [
  {
    title: 'Placement & Orientation Sessions',
    key: 'Placement',
    required: true,
    toolTipContent:
      'Attendance in these sessions is mandatory for placement eligibility. You must have 100% attendance in these sessions.',
    type: 1,
    color: '#FAB300'
  },
  {
    title: 'Career Practice Sessions',
    key: 'career_practice',
    toolTipContent: 'These sessions are optional but important for your career',
    type: 2,
    color: '#5095FC',
    required: false
  }
];

const Resume_Approval_Status = {
  0: {
    title: <p>Verification Pending</p>,
    icon: <span class='material-symbols-rounded'>schedule</span>,
    className: 'resume-pending'
  },
  1: {
    title: <p>Verified</p>,
    icon: <span class='material-symbols-outlined filled'>check_circle</span>,
    className: 'resume-success'
  },
  2: {
    title: <p>Rejected</p>,
    icon: <span class='material-symbols-outlined filled'>cancel</span>,
    className: 'resume-reject'
  },
  3: {
    title: <p>Verification Pending</p>,
    icon: <span class='material-symbols-rounded'>schedule</span>,
    className: 'resume-pending'
  }
};

const extractProgramIdFromUrl = (url, routes) => {
  for (const route of Object.values(routes)) {
    const routeRegex = route.replace(/:[^\s/]+/g, '([^/]+)');
    const match = url.match(new RegExp(`^${routeRegex}$`));
    if (match) {
      return match[1]; // Assuming the programid is always the first parameter
    }
  }
  return null;
};

const cleanUrl = (url) => {
  // Remove dynamic segments like /:id, /:programid, etc.
  return url.replace(/\/:[^\/]+/g, '').replace(/\/null/g, '');
};

export const convertUnixTimestampToDate = (unixTimestamp) => {
  const date = new Date((unixTimestamp + 19800) * 1000);
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];
  // const dayOfWeek = days[date.getUTCDay()];
  const day = date.getUTCDate();
  const month = months[date.getUTCMonth()];
  const year = date.getUTCFullYear();
  let hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  return `${day} ${month}, ${year}, ${hours}:${minutes} ${ampm}`;
};

export const extensions = {
  applicationExtensions: [
    'zip',
    'json',
    'xml',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'js',
    'pptx'
  ],
  imageExtensions: [
    'png',
    'jpeg',
    'jpg',
    'gif',
    'svg',
    'webp',
    'bmp',
    'tiff',
    'tif'
  ],

  audioExtensions: ['mp3', 'wav', 'ogg', 'weba', 'aac'],
  videoExtensions: ['mp4', 'webm', 'ogv', 'mov', 'avi'],
  textExtensions: ['txt', 'html', 'htm', 'css', 'js', 'csv', 'pdf']
};

export const timeAgo = (unixTimestamp) => {
  const now = Date.now() / 1000;
  const secondsElapsed = now - unixTimestamp;

  const units = [
    { name: 'year', seconds: 60 * 60 * 24 * 365 },
    { name: 'month', seconds: 60 * 60 * 24 * 30 },
    { name: 'day', seconds: 60 * 60 * 24 },
    { name: 'hour', seconds: 60 * 60 },
    { name: 'minute', seconds: 60 },
    { name: 'second', seconds: 1 }
  ];

  for (let unit of units) {
    const interval = Math.floor(secondsElapsed / unit.seconds);
    if (interval >= 1) {
      return `${interval} ${unit.name}${interval !== 1 ? 's' : ''} ago`;
    }
  }

  return 'just now';
};

export const hasTimeElapsed = (unixTimestamp, minutes) => {
  const currentTime = Math.floor(Date.now() / 1000);
  const elapsedTime = currentTime - unixTimestamp;
  const elapsedMinutes = elapsedTime / 60;

  return elapsedMinutes >= minutes;
};

export const uploadIcons = (obj) => {
  const theme = localStorage?.getItem('vlearn-theme') || '';
  const extension =
    obj?.filename?.split('.')?.at(-1) || obj?.name?.split('.')?.at(-1);
  if (['zip'].includes(extension)) {
    return theme == 'dark' ? zipIconDark : zipIcon;
  } else if (extensions.applicationExtensions.includes(extension)) {
    return theme == 'dark' ? docIconDark : docIcon;
  } else if (extensions.imageExtensions.includes(extension)) {
    return theme == 'dark' ? imageIconDark : imageIcon;
  } else if (extensions.videoExtensions.includes(extension)) {
    return theme == 'dark' ? videoIconDark : videoIcon;
  } else if (extensions.textExtensions.includes(extension)) {
    return theme == 'dark' ? pdfIconDark : pdfIcon;
  } else {
    return theme == 'dark' ? otherIconDark : otherIcon;
  }
};

export const formatLinks = (obj, token, allowDownload = false) => {
  const extension = obj?.filename?.split('.')?.pop();
  let href = '';
  const tokenParam = `${obj.fileurl.includes('?') ? '&' : '?'}token=`;

  if (extensions.applicationExtensions.includes(extension)) {
    href = `${obj.fileurl}${tokenParam}${token}`;
  } else if (extensions.imageExtensions.includes(extension)) {
    href = `${obj.fileurl.replace(/\/webservice\//, '/')}${tokenParam}${btoa(
      token
    )}`;
  } else if (extensions.audioExtensions.includes(extension)) {
    href = `${obj.fileurl.replace(/\/webservice\//, '/')}${tokenParam}${btoa(
      token
    )}`;
  } else if (extensions.videoExtensions.includes(extension)) {
    href = `${obj.fileurl.replace(/\/webservice\//, '/')}${tokenParam}${btoa(
      token
    )}`;
  } else if (extensions.textExtensions.includes(extension)) {
    href = `${obj.fileurl.replace(/\/webservice\//, '/')}${tokenParam}${btoa(
      token
    )}`;
  }

  if (allowDownload) {
    const downloadLink = document.createElement('a');
    downloadLink.href = href;
    downloadLink.download = obj.filename || 'download';
    downloadLink.target = '_blank';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
  return href;
};

export const formatFileSize = (bytes) => {
  const units = ['B', 'KB', 'MB', 'GB'];
  let size = bytes;
  let unitIndex = 0;
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  if (units[unitIndex] === 'GB') {
    size = size.toFixed(1);
  } else {
    size = Math.round(size);
  }

  return `${size} ${units[unitIndex]}`;
};

export const formatLinksForFile = (obj, token) => {
  const extension = obj?.filename?.split('.')?.pop();
  let href = '';
  const removeForceDownload = (url) =>
    url.replace(/([?&])forcedownload=1(&|$)/, '$1').replace(/&$/, '');
  const tokenParam = `${obj.fileurl.includes('?') ? '&' : '?'}token=${btoa(
    token
  )}`;

  if (extensions.applicationExtensions.includes(extension)) {
    href = removeForceDownload(`${obj.fileurl}&token=${token}`);
  } else if (extensions.imageExtensions.includes(extension)) {
    href = removeForceDownload(
      `${obj.fileurl.replace(/\/webservice\//, '/')}&token=${btoa(tokenParam)}`
    );
  } else if (extensions.audioExtensions.includes(extension)) {
    href = removeForceDownload(
      `${obj.fileurl.replace(/\/webservice\//, '/')}&token=${btoa(tokenParam)}`
    );
  } else if (extensions.videoExtensions.includes(extension)) {
    href = removeForceDownload(
      `${obj.fileurl.replace(/\/webservice\//, '/')}&token=${btoa(tokenParam)}`
    );
  } else if (extensions.textExtensions.includes(extension)) {
    href = removeForceDownload(
      `${obj.fileurl.replace(/\/webservice\//, '/')}&token=${tokenParam}`
    );
  }
  return href;
};

export const formatLinksForFolder = (obj, token) => {
  const extension = obj?.filename?.split('.')?.pop();
  let href = '';
  const tokenParam = `${obj.fileurl.includes('?') ? '&' : '?'}token=${btoa(
    token
  )}`;
  if (extensions.applicationExtensions.includes(extension)) {
    href = `${obj.fileurl}&token=${token}`;
  } else if (extensions.imageExtensions.includes(extension)) {
    href = `${obj.fileurl.replace(/\/webservice\//, '/')}&token=${btoa(
      tokenParam
    )}`;
  } else if (extensions.audioExtensions.includes(extension)) {
    href = `${obj.fileurl.replace(/\/webservice\//, '/')}&token=${btoa(
      tokenParam
    )}`;
  } else if (extensions.videoExtensions.includes(extension)) {
    href = `${obj.fileurl.replace(/\/webservice\//, '/')}&token=${btoa(
      tokenParam
    )}`;
  } else if (extensions.textExtensions.includes(extension)) {
    href = `${obj.fileurl.replace(/\/webservice\//, '/')}&token=${tokenParam}`;
  }
  return href;
};

const processSelfPacedQuizzes = (rawData, scoreThreshold = 70) => {
  const result = [];

  Object.values(rawData || {}).forEach((course = {}) => {
    const allQuizzes = [
      ...(course.mandatoryQuizzes || []),
      ...(course.practiceQuizzes || [])
    ];

    allQuizzes.forEach((quiz = {}) => {
      let selfPacedStatus = 'not_attempted';

      const isSubmitted = quiz.status?.toLowerCase() === 'submitted';
      const max = Number(quiz.maxMarks) || 0;
      const scored = Number(quiz.scoredMarks) || 0;

      if (isSubmitted && max > 0) {
        const percent = (scored / max) * 100;
        selfPacedStatus = percent >= scoreThreshold ? 'cleared' : 'not_cleared';
      }

      result.push({
        cmid: quiz.cmId,
        quizname: quiz.activityName || 'Untitled Quiz',
        coursename: course.courseName || 'Untitled Course',
        scoredMarks: scored,
        maxMarks: max,
        status: quiz.status || 'Not Submitted',
        selfPacedStatus,
        type: 'quiz'
      });
    });
  });

  return result;
};

const Nav = [
  {
    link: ROUTES.HOME,
    symbol: 'home',
    title: 'Home',
    cleverTapKey: HOME_SECTIONS.Sidebar.activity.Sidebar_Home,
    isHidden: false
  },
  {
    link: ROUTES.PROGRAM_TIMELINE,
    symbol: 'local_library',
    title: 'Classoom',
    cleverTapKey: HOME_SECTIONS.Sidebar.activity.sidebar_classroom,
    isHidden: true
  },
  {
    link: ROUTES.PROGRESS_HUB,
    symbol: 'bar_chart_4_bars',
    title: 'Progress',
    cleverTapKey: HOME_SECTIONS.Sidebar.activity.sidebar_progress,
    isHidden: true
  },
  {
    link: ROUTES.SKILL_REPORT,
    symbol: (
      <svg width='26' height='37' viewBox='0 0 26 37' fill='none'>
        <mask
          id='mask0_25193_3399'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='1'
          y='12'
          width='25'
          height='25'
        >
          <rect
            x='1.68359'
            y='13.1357'
            width='23'
            height='23'
            fill='#D9D9D9'
            stroke='#D3D3D3'
          />
        </mask>
        <g mask='url(#mask0_25193_3399)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M23.4471 22.1487L18.73 23.7211C18.6685 24.2079 18.292 24.5965 17.8111 24.6764L17.3795 28.4348C17.5351 28.626 17.6285 28.87 17.6285 29.1358C17.6285 29.3068 17.5898 29.4689 17.5208 29.6136L20.1836 32.6357L19.5583 33.1867L16.9064 30.1769C16.7853 30.2221 16.6542 30.2469 16.5174 30.2469C16.1523 30.2469 15.8284 30.0709 15.6259 29.7991L11.1045 28.8889C10.9136 29.0433 10.6706 29.1358 10.406 29.1358C10.38 29.1358 10.3541 29.1349 10.3285 29.1331L6.5166 33.5803L5.88389 33.038L9.5618 28.7471C9.39542 28.5528 9.29492 28.3005 9.29492 28.0247C9.29492 27.7668 9.38278 27.5294 9.53019 27.3409L8.10862 24.1333C7.55047 24.0962 7.10505 23.647 7.074 23.0872L3.18359 21.3582L3.52204 20.5966L7.34484 22.2957C7.54855 22.0616 7.84868 21.9136 8.18338 21.9136C8.65255 21.9136 9.0538 22.2044 9.21673 22.6155L12.0723 21.9254C12.0723 21.9215 12.0723 21.9176 12.0723 21.9136C12.0723 21.5023 12.2958 21.1432 12.6279 20.9511V14.8025H13.4613V20.8375C13.9404 20.9609 14.2945 21.3959 14.2945 21.9136C14.2945 21.9732 14.2898 22.0317 14.2808 22.0887L16.7765 22.8661C16.9803 22.6235 17.286 22.4692 17.6277 22.4692C17.9913 22.4692 18.314 22.6438 18.5167 22.9138L23.1836 21.3582L23.4471 22.1487ZM16.5359 23.3731L14.0566 22.6008C13.9082 22.789 13.7003 22.9281 13.4613 22.9897V24.5989L16.5166 23.5805V23.5803C16.5166 23.5095 16.5232 23.4402 16.5359 23.3731ZM12.2168 22.4621L9.30341 23.1661L12.6279 24.6437V22.8761C12.4568 22.7772 12.3146 22.6339 12.2168 22.4621ZM8.66817 24.0247L9.98505 26.9961C10.1149 26.9429 10.257 26.9136 10.406 26.9136C10.6206 26.9136 10.821 26.9744 10.9909 27.0798L12.3885 25.4492L8.88036 23.8901C8.81527 23.9425 8.74414 23.9878 8.66817 24.0247ZM11.4547 28.3927L15.4075 29.1884C15.4067 29.171 15.4062 29.1534 15.4062 29.1358C15.4062 28.9491 15.4523 28.7733 15.5336 28.6189L13.1186 25.878L11.4897 27.7783C11.5077 27.8576 11.5171 27.94 11.5171 28.0247C11.5171 28.1537 11.4952 28.2775 11.4547 28.3927ZM16.8612 28.0789L17.2574 24.6283C17.0943 24.5706 16.9486 24.4759 16.8305 24.3543L13.782 25.3704L16.1696 28.0802C16.279 28.0441 16.3959 28.0247 16.5174 28.0247C16.6374 28.0247 16.7529 28.0437 16.8612 28.0789ZM13.0574 24.8025L13.0332 24.8238L12.9852 24.8025H13.0574Z'
            fill='var(--tertiary-text-color)'
          />
          <path
            d='M11.8301 15.378C12.1707 15.1322 12.58 15 13 15C13.42 15 13.8293 15.1322 14.1699 15.378L22.1692 21.1186C22.5143 21.3673 22.7711 21.7195 22.9024 22.1242C23.0337 22.5289 23.0325 22.9649 22.8991 23.3688L19.8594 32.6299C19.7269 33.029 19.4721 33.3762 19.131 33.6222C18.7899 33.8682 18.38 34.0004 17.9595 34H8.04045C7.61998 34.0004 7.21007 33.8682 6.86901 33.6222C6.52795 33.3762 6.27308 33.029 6.14063 32.6299L3.10091 23.3688C2.9675 22.9649 2.96635 22.5289 3.09761 22.1242C3.22888 21.7195 3.48573 21.3673 3.83084 21.1186L11.8301 15.378Z'
            stroke='var(--tertiary-text-color)'
            strokeWidth='1.66667'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12H20C23.3137 12 26 9.31371 26 6C26 2.68629 23.3137 0 20 0H6ZM5.204 4.992L7.836 9H9.028V3.256H7.908V7.064L5.404 3.256H4.092V9H5.204V4.992ZM14.0732 9V7.944H11.4252V6.568H13.7772V5.52H11.4252V4.312H14.0172V3.256H10.2092V9H14.0732ZM18.3019 4.984L19.3739 9H20.6059L22.0859 3.256H20.8939L19.9579 7.168L18.9339 3.256H17.6939L16.6379 7.152L15.7099 3.256H14.5259L15.9979 9H17.2299L18.3019 4.984Z'
          fill='url(#paint0_linear_25193_3399)'
        />
        <defs>
          <linearGradient
            id='paint0_linear_25193_3399'
            x1='1.68359'
            y1='-4.86426'
            x2='28.6836'
            y2='13.6357'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#F650FC' />
            <stop offset='1' stopColor='#73ABFF' />
          </linearGradient>
        </defs>
      </svg>
    ),
    filledSymbol: <img src={skillSyncSelectedIcon} />,
    title: 'Skill Sync',
    cleverTapKey: HOME_SECTIONS.Sidebar.activity.sidebar_progress,
    isHidden: true
  },

  {
    link: ROUTES.LEARNING_HUB,
    symbol: 'newsmode',
    title: 'Resources',
    cleverTapKey: HOME_SECTIONS.Sidebar.activity.Sidebar_Resources,
    isHidden: false
  },
  {
    link: ROUTES.VRISE,
    symbol: 'business_center',
    title: 'Careers',
    cleverTapKey: HOME_SECTIONS.Sidebar.activity.Sidebar_Careers,
    isHidden: false
  },
  {
    link: ROUTES.REFER_N_EARN,
    symbol: (
      <svg
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M10 14H12C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10H9C8.4 10 7.9 10.2 7.6 10.6L2 16M6 20L7.6 18.6C7.9 18.2 8.4 18 9 18H13C14.1 18 15.1 17.6 15.8 16.8L20.4 12.4C20.7859 12.0353 21.0111 11.5323 21.0261 11.0016C21.0411 10.4708 20.8447 9.95589 20.48 9.57C20.1153 9.18411 19.6123 8.95889 19.0816 8.94389C18.5508 8.92888 18.0359 9.12533 17.65 9.49L13.45 13.39M1 15L7 21M17.9 8C17.9 9.60163 16.6016 10.9 15 10.9C13.3984 10.9 12.1 9.60163 12.1 8C12.1 6.39837 13.3984 5.1 15 5.1C16.6016 5.1 17.9 6.39837 17.9 8ZM8 4C8 5.65685 6.65685 7 5 7C3.34315 7 2 5.65685 2 4C2 2.34315 3.34315 1 5 1C6.65685 1 8 2.34315 8 4Z'
          stroke='var(--secondary-text-color)'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </svg>
    ),
    filledSymbol: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <g clip-path='url(#clip0_22460_5889)'>
          <path
            d='M10.8867 15.3H13.0837C13.6664 15.3 14.2253 15.0682 14.6373 14.6556C15.0493 14.2431 15.2808 13.6835 15.2808 13.1C15.2808 12.5165 15.0493 11.9569 14.6373 11.5444C14.2253 11.1318 13.6664 10.9 13.0837 10.9H9.78817C9.12906 10.9 8.5798 11.12 8.25024 11.56L2.09852 17.5M6.49261 21.9L8.25024 20.36C8.5798 19.92 9.12906 19.7 9.78817 19.7H14.1823C15.3906 19.7 16.4892 19.26 17.2581 18.38L22.3113 13.54C22.7352 13.1389 22.9826 12.5855 22.9991 12.0017C23.0156 11.4179 22.7998 10.8515 22.3992 10.427C21.9986 10.0025 21.446 9.75478 20.863 9.73828C20.28 9.72177 19.7143 9.93786 19.2904 10.339L14.6766 14.629M1 16.4L7.59113 23M19.565 8.7C19.565 10.4618 18.1387 11.89 16.3793 11.89C14.6199 11.89 13.1936 10.4618 13.1936 8.7C13.1936 6.93821 14.6199 5.51 16.3793 5.51C18.1387 5.51 19.565 6.93821 19.565 8.7ZM8.68965 4.3C8.68965 6.12254 7.21418 7.6 5.39409 7.6C3.574 7.6 2.09852 6.12254 2.09852 4.3C2.09852 2.47746 3.574 1 5.39409 1C7.21418 1 8.68965 2.47746 8.68965 4.3ZM8.68965 4.3C8.68965 6.12254 7.21418 7.6 5.39409 7.6C3.574 7.6 2.09852 6.12254 2.09852 4.3C2.09852 2.47746 3.574 1 5.39409 1C7.21418 1 8.68965 2.47746 8.68965 4.3Z'
            stroke='#5095FC'
            stroke-width='2'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_22460_5889'>
            <rect width='24' height='24' fill='white' />
          </clipPath>
        </defs>
      </svg>
    ),
    title: 'Refer & Earn',
    cleverTapKey: HOME_SECTIONS.Sidebar.activity.sidebar_refer_and_earn,
    isHidden: false
  },
  {
    link: `https://herovired.myfreshworks.com/login/auth/1666776251941?client_id=451980303908285122&redirect_uri=https://herovired.freshdesk.com/freshid/customer_authorize_callback?hd=herovired.freshdesk.com&learner_email&falsetoken`,
    symbol: 'confirmation_number',
    title: 'My Tickets',
    external: true,
    cleverTapKey: HOME_SECTIONS.Sidebar.activity.Sidebar_Raise_A_Ticket,
    isHidden: false
  },
  {
    link: '/page-activity/373/forum/83872',
    symbol: 'forum',
    title: 'Forum',
    cleverTapKey: HOME_SECTIONS.Sidebar.activity.sidebar_forum_bmu_munjal,
    isBmu: true
  }
];

export const customToast = (
  headerText = '',
  description = '',
  className = '',
  autoClose = 3000
) => {
  toast.success(
    <SuccessToastMessage
      headerText={headerText}
      description={description}
      className={className}
    />,
    {
      className: 'Toastify__toast--show',
      onOpen: () => {
        setTimeout(() => {
          document
            .querySelector('.Toastify__toast--show')
            .classList.add('Toastify__toast--hide');
        }, autoClose);
      }
    }
  );
};

export const canPerformAction = (
  LAST_EVENT_KEY = 'temp',
  DURATION = 7200000
) => {
  const now = Date.now();
  const lastEventTime = localStorage.getItem(LAST_EVENT_KEY);

  if (!lastEventTime || now - parseInt(lastEventTime, 10) >= DURATION) {
    localStorage.setItem(LAST_EVENT_KEY, now.toString());
    return true;
  } else {
    const remainingTime = DURATION - (now - parseInt(lastEventTime, 10));
    return false;
  }
};

export const getYoutubeEmbedUrl = (url) => {
  if (!url) return '';
  if (
    url?.includes('youtube.com/embed/') ||
    url?.includes('youtube-nocookie.com/embed/')
  ) {
    return url;
  }
  const videoIdMatch = url?.match(
    /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/
  );
  const videoId = videoIdMatch ? videoIdMatch?.[1] : null;

  if (videoId) {
    return `https://www.youtube.com/embed/${videoId}`;
  }
  return url;
};

function checkExistingKey(id) {
  let storage = localStorage.getItem('showedEnrolled');
  if (storage == '0' || storage == '1') {
    localStorage.removeItem('showedEnrolled');
    return null;
  }
  if (storage) {
    const temp = JSON.parse(storage || '[]');
    const value = temp?.findIndex((val) => {
      return val?.parentId == id || val?.childId == id;
    });
    if (value >= 0) {
      return {
        index: value,
        data: temp[value],
        storage: temp
      };
    } else {
      return null;
    }
  }
  return null;
}

const handleEnabledState = (profileData) => {
  let isPersonalDetailsEnabled = true;
  let isProfessionalDetailsEnabled = false;
  let isEducationalQualificationsEnabled = false;
  let isSkillProficiencyEnabled = false;
  let isCareersInformationEnabled = false;

  let workExpData = profileData?.workExperience;
  let educationalQualifications = {};
  profileData?.educationalQualifications?.map(
    (obj) => (educationalQualifications[obj?.type] = obj)
  );

  if (
    profileData?.firstName &&
    // profileData?.lastName &&
    profileData?.gender &&
    profileData?.emailAddress &&
    profileData?.phone &&
    profileData?.state &&
    profileData?.city &&
    profileData?.currentAddress &&
    profileData?.pin
  ) {
    isProfessionalDetailsEnabled = true;
  }

  if (
    isProfessionalDetailsEnabled &&
    workExpData?.totalWorkExperience &&
    workExpData?.currentDesignation &&
    workExpData?.currentOrganization &&
    workExpData?.salaryPerAnnum &&
    workExpData?.resumeLocation &&
    workExpData?.resumeStatus &&
    workExpData?.socialProfiles?.length > 0
  ) {
    isEducationalQualificationsEnabled = true;
  }

  if (
    isEducationalQualificationsEnabled &&
    educationalQualifications?.['TENTH']?.institutionName &&
    educationalQualifications?.['TENTH']?.marks &&
    educationalQualifications?.['TWELFTH']?.institutionName &&
    educationalQualifications?.['TWELFTH']?.marks &&
    educationalQualifications?.['UG']?.level &&
    // educationalQualifications?.['UG']?.institutionName &&
    educationalQualifications?.['UG']?.collegeName &&
    educationalQualifications?.['UG']?.specialization &&
    educationalQualifications?.['UG']?.yearOfPassing
  ) {
    isSkillProficiencyEnabled = true;
    isCareersInformationEnabled = true;
  }

  return {
    isPersonalDetailsEnabled,
    isProfessionalDetailsEnabled,
    isEducationalQualificationsEnabled,
    isSkillProficiencyEnabled,
    isCareersInformationEnabled
  };
};

function setFreshworksWidgetHeightTo50() {
  const frameWrapper = document.getElementById('freshworks-frame-wrapper');

  if (frameWrapper) {
    frameWrapper.style.height = 'calc(100vh - 89px - 120px)';
  } else {
    console.log('freshworks-frame-wrapper element not found!');
  }
}

const handleWidgetLauncherClick = (lpid = '') => {
  // ^•ﻌ•^
  let userData = JSON.parse(localStorage.getItem('user'));
  window.FreshworksWidget('open');
  window.FreshworksWidget('prefill', 'ticketForm', {
    name: userData?.name + ' ' + userData?.lastName,
    email: userData?.email,
    'customFields.cf_reference_link': window?.location?.href,
    'customFields.cf_user_id': userData?.userid,
    'customFields.cf_lpid': lpid
  });
  window.FreshworksWidget('disable', 'ticketForm', [
    'name',
    'email',
    'custom_fields.cf_reference_link'
  ]);
  window?.FreshworksWidget('hide', 'ticketForm', [
    'custom_fields.cf_user_id',
    'custom_fields.cf_lpid'
  ]);
  setTimeout(() => {
    setFreshworksWidgetHeightTo50();
  }, 2500);
};

const generateRandomTextRegex = (length) => {
  return Array(length)
    .fill('a')
    .join('')
    .replace(/a/g, () => Math.random().toString(36).charAt(2));
};

// utils/getQuizAndHandsonActivities.js

const getActivityCounts = (courseId, gradeDetailsData) => {
  const activityCounts = {};

  const courseData = gradeDetailsData?.[courseId];
  if (!courseData) return activityCounts;

  const allActivityArrays = [
    courseData?.mandatoryQuizzes,
    courseData?.practiceQuizzes,
    // courseData.mandatoryAssignments,
    // courseData.practiceAssignments,
    // courseData.mandatoryOtherActivity,
    // courseData.practiceOtherActivity,
    courseData?.handsonActivities
  ];

  allActivityArrays.forEach((activityList) => {
    activityList?.forEach((activity) => {
      const type = activity?.type;
      if (type) {
        activityCounts[type] = (activityCounts[type] || 0) + 1;
      }

      if (activity?.handson_type === '1') {
        activityCounts['handson'] = (activityCounts['handson'] || 0) + 1;
      }
    });
  });

  return activityCounts;
};

const timelineOverview = [
  // {
  //   title: 'Live Sessions',
  //   icon: <span className='material-symbols-rounded icon'>live_tv</span>,
  //   key: 'zoom'
  // },
  // {
  //   title: 'Videos',
  //   icon: <span className='material-symbols-rounded icon'>play_circle</span>,
  //   key: 'videofile'
  // },
  {
    title: 'Quizzes',
    icon: (
      <span className='material-symbols-rounded icon'>contact_support</span>
    ),
    key: 'quiz'
  },
  // {
  //   title: 'Assignments',
  //   icon: <span className='material-symbols-rounded icon'>assignment</span>,
  //   key: 'assign'
  // },
  {
    title: 'Playgrounds',
    icon: <span class='material-symbols-outlined'>terminal</span>,
    key: 'handson'
  }
];

const getHandsonActivities = (programModule, gradeDetailsData) => {
  const lastAccessedCourse = programModule.find(
    (course) => course.lastaccess === 1
  );
  const courseId = lastAccessedCourse
    ? lastAccessedCourse.courseid
    : programModule[0]?.courseid;

  const courseData = gradeDetailsData?.[courseId];

  if (!courseData) return [];

  return courseData?.handsonActivities || [];
};

const checkQuizzes = (gradeDetailsData) => {
  let totalQuizzes = 0;
  let totalSubmittedQuizzes = 0;
  let totalSubmittedQuizPercentage = 0;

  for (let courseId in gradeDetailsData) {
    let course = gradeDetailsData[courseId];
    let allQuizzes = [
      ...(course?.mandatoryQuizzes || []),
      ...(course?.practiceQuizzes || [])
    ];
    totalQuizzes += allQuizzes?.length; // Increment total quizzes

    allQuizzes?.forEach((quiz) => {
      if (quiz?.status === 'Submitted') {
        totalSubmittedQuizzes++; // Increment submitted quizzes

        const scorePercentage = (quiz?.scoredMarks / quiz?.maxMarks) * 100;

        // Add the percentage to the total for averaging later
        totalSubmittedQuizPercentage += scorePercentage;
      }
    });
  }
  const averageSubmittedQuizPercentage =
    totalSubmittedQuizzes > 0 ? totalSubmittedQuizPercentage / totalSubmittedQuizzes : 0;

  const submittedQuizFraction = `${totalSubmittedQuizzes} / ${totalQuizzes}`;

  return {
    totalQuizzes,
    totalSubmittedQuizzes,
    averageSubmittedQuizPercentage,
    submittedQuizFraction,
  };
};

export {
  carreerSession,
  data,
  constantLogin,
  constantSignUp,
  formatDate,
  DATE_WEEK_STRING_FORMAT,
  courseStatus,
  getUrlQueryParams,
  activityIcon,
  searchPopover,
  CURRENT_INDUSTRY,
  PREFERRED_CITY_LIST,
  SOCIAL_PROFILE,
  SKILLS_PLACEHOLDER,
  UG_COURSE_LIST,
  PG_COURSE_LIST,
  handleLastDecimalChange,
  getDaysDiff,
  courseStatusVal,
  DEFAULT_SOCIAL_PROFILE_SELECT_OPTION,
  parseQueryParams,
  htmlDataParser,
  parseInteger,
  ACCESS_TYPE,
  PROGRESS_TAB,
  getIp,
  resourceSidebarNavItem,
  PER_PAGE,
  SUPPORTED_PAGE_ACTIVITY,
  DATE_WEEKTIME_STRING_FORMAT,
  QUIZ_TYPE,
  progressSectionCardDetails,
  QUIZ_ANSWER_STATUS,
  getFileType,
  calculatePercentage,
  Resume_Approval_Status,
  getStatus,
  LiveIcon,
  handleRedirection,
  handleStringToNumber,
  extractProgramIdFromUrl,
  cleanUrl,
  getUrlReplace,
  Nav,
  processSelfPacedQuizzes,
  checkExistingKey,
  handleEnabledState,
  handleWidgetLauncherClick,
  generateRandomTextRegex,
  getActivityCounts,
  timelineOverview,
  getHandsonActivities,
  checkQuizzes
};
